<template>
  <div class="items-end bg-white">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ViewFooter'
};
</script>
